import "../../chunks/index4.js";
function load({ url }) {
}
export {
  load
};
